/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".welcome[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:center;align-items:center}.welcome__close[_ngcontent-%COMP%]{cursor:pointer;align-self:flex-end}.welcome__button[_ngcontent-%COMP%]{margin:auto 8px}"];
export { styles as styles };
